<template>
  <qx-card title="列表">
    <LogRightDialog
      ref="logRightDialog"
      busiCode="22000023"
    />
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl='payManagerBO.ajax?cmd=doQueryAllPayManager'
          :params="fullSearchData"
          bizName="管理费用数据导出"
          bizCode="exp100031"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section  slot-scope="scope">
              <section v-if="scope.column.property === 'busiCode'">
                <span class="primary cur" @click="toDetail(scope.row)">{{scope.row[scope.column.property]}}</span>
              </section>
              <!-- 申请金额 -->
              <section v-if="scope.column.property === 'payAmt'">
                <span
                  v-if="scope.row.payAmt > 0 && (
                    scope.row.payType !== 4302 &&
                    scope.row.payType !== 4303 &&
                    scope.row.payType !== 4300
                  )"
                >
                  {{scope.row.payAmt}}
                </span>
                <span v-else-if="!scope.row.payAmt || scope.row.payAmt === '0'">--</span>
                <el-popover
                  v-else-if="scope.row.payType === 4300"
                  title="申请金额"
                  trigger="hover"
                  :content="scope.row.etcTrafficFee + ' （ETC通行费）+ ' + scope.row.etcServiceFee + '（服务费）+' + scope.row.etcLateFee + '（滞纳金）'">
                  <div slot="reference" class="primary cur">{{scope.row[scope.column.property]}}</div>
                </el-popover>
                <el-popover
                  v-else
                  title="申请金额"
                  trigger="hover"
                  :content="scope.row.principal + ' （本金）+ ' + scope.row.interest + '（利息）'">
                  <div slot="reference" class="primary cur">{{scope.row[scope.column.property]}}</div>
                </el-popover>
                <span v-if="scope.row[scope.column.property] === '0'">{{scope.row[scope.column.property]}}</span>
              </section>
              <!-- 申请金额 end -->
              <!-- 抵扣借支 -->
              <section v-if="scope.column.property === 'deductAmount'">
                <DeductDetail
                  v-if="scope.row[scope.column.property] !== '0'"
                  :itemData="scope.row"
                />
                <span v-if="scope.row[scope.column.property] === '0'">{{scope.row[scope.column.property]}}</span>
              </section>
              <!-- 抵扣借支 end -->
              <section
                v-if="
                  scope.column.property !== 'busiCode' &&
                  scope.column.property !== 'payAmt' &&
                  scope.column.property !== 'deductAmount'
                "
              >{{scope.row[scope.column.property]}}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="160" fixed="right">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions permpisions="" v-if="scope.row.state==0 || scope.row.state==4">
                  <span class="primary cur" @click="toDetail(scope.row, 'approve')">审核</span>
                </qx-permpisions>
                <qx-permpisions permpisions="" v-if="scope.row.state === 0 || scope.row.state === 1">
                  <span class="primary cur" @click="toEdit(scope.row.payId)">修改</span>
                </qx-permpisions>
                <qx-permpisions permpisions="">
                  <el-dropdown>
                    <span class="el-dropdown-link cur primary">
                      <i class="iconfont">&#xe609;</i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <qx-permpisions v-if="scope.row.state === 0 || scope.row.state === 1">
                        <el-dropdown-item @click.native="cancel(scope.row)">取消</el-dropdown-item>
                      </qx-permpisions>
                      <qx-permpisions>
                        <el-dropdown-item @click.native="showLog(scope.row.payId)">日志</el-dropdown-item>
                      </qx-permpisions>
                    </el-dropdown-menu>
                  </el-dropdown>
                </qx-permpisions>
                <!-- 操作按钮 end -->
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import DeductDetail from './deductDetail';
import {
  manageList,
  manageCancel,
} from 'api/cost';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
    DeductDetail,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'busiCode',
            label: '申请单号',
          },
          {
            prop: 'applyUserName',
            label: '申请人',
          },
          {
            prop: 'applyOrgName',
            label: '申请人归属部门',
          },
          {
            prop: 'applyTime',
            label: '申请时间',
          },
          {
            prop: 'feeAscriptionDate',
            label: '费用归属日期',
          },
          {
            prop: 'payTypeName',
            label: '费用类型',
          },
          {
            prop: 'orgName',
            label: '费用归属部门',
          },
          {
            prop: 'payAmt',
            label: '申请金额',
          },
          {
            prop: 'isNeedBillName',
            label: '是否开票',
          },
          {
            prop: 'deductAmount',
            label: '抵扣借支',
          },
          {
            prop: 'shouldPayAmount',
            label: '应付金额',
          },
          {
            prop: 'payRemark',
            label: '申请原因',
          },
          {
            prop: 'receUserName',
            label: '收款方名称',
          },
          {
            prop: 'receBankName',
            label: '收款银行',
          },
          {
            prop: 'receBankNo',
            label: '收款账号',
          },
          {
            prop: 'stateName',
            label: '状态',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: manageList,
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核管理费用' : '管理费用详情',
        url: `/manage/cost/manage/detail?id=${item.payId}&type=${type}`,
        full: true,
      });
    },
    toLine (item) {
      this.jump({
        label: '线路档案',
        url: '/manage/archives/customer/line?companyName=' + item.companyName,
      });
    },
    toLineEdit (id) {
      this.jump({
        label: '新增线路',
        url: `/manage/archives/customer/line/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
    toEdit (id) {
      this.jump({
        label: (id ? '修改' : '新增') + '管理费用',
        url: `/manage/cost/manage/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
    async cancel (item) {
      const confirmRes = await this.$confirm('是否确定取消该借支？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
      if (confirmRes === 'confirm') {
        const delRes = await manageCancel({
          payId: item.payId,
          state: 5,
        });
        if (!delRes.failed) {
          this.$message({
            type: 'success',
            message: '取消成功',
          });
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
